// extracted by mini-css-extract-plugin
var _1 = "EmailAccountSelectDropdownListItem-moduleicon__CM_za SelectEntityItemAvatar-moduleavatar__zeGPU";
export { _1 as "icon" }
